import { createMemo, JSX, Show, splitProps } from 'solid-js'
import styles from './st-image.module.css'
import { theme, transformImagePath } from 'common';

const NO_PHOTO_PATH = "Images/Revelation/NOPhoto.png";

export class ImageProps {
    alt = '';
    useDefaultPhoto?= false;
}

export default function Image(props: ImageProps & JSX.HTMLElementTags['img']) {
    const [local, other] = splitProps(props, ['src', 'class', 'children'])

    const src = createMemo(() => {
        // transformImagePath calls theme() under the hood, so this should be reactive
        return props.useDefaultPhoto
            ? transformImagePath(props.src || NO_PHOTO_PATH)
            : transformImagePath(props.src);
    })

    return (
        <Show when={src()}>
            <img
                class={`${styles['st-image']} ${local.class ?? ''}`}
                src={src()}
                {...other}
            />
        </Show>
    );
}

Image.defaultProps = new ImageProps();